import React from 'react'
import { ArrowLeft } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import Breadcrumb from 'react-bootstrap/Breadcrumb'

const ReportBreadcrumb = ({text, handleBreadcrumbClick}) => {
    return (
        <Breadcrumb>
            <Breadcrumb.Item linkProps={{ to: '/dashboard' }} linkAs={Link}>
                <div
                    className="d-flex justify-content-center align-items-center"
                    onClick={handleBreadcrumbClick}
                >
                    <ArrowLeft
                        className="arrow-icon-left"
                        size={13}
                    />
                    <span>
                        {text}
                    </span>
                </div>
            </Breadcrumb.Item>
        </Breadcrumb>
    )
}

export default ReportBreadcrumb